import { localStorageCache } from "core/store";

export class TokenStore {
  tokenKey = "token";

  isAuthenticated = () => !!this.getAuthToken();

  getAuthToken() {
    const userData = this.getUserInfo();
    return userData?.token || "";
  }

  isSSOToken() {
    const userData = this.getUserInfo();
    return userData?.isSSO;
  }

  setToken(token) {
    const uuid = crypto.randomUUID();
    localStorage.setItem("sessionid", uuid);
    localStorageCache.setItem(this.tokenKey, token);
  }

  deleteToken() {
    localStorageCache.removeItem(this.tokenKey);
  }

  getUserInfo() {
    const userData = localStorageCache.getItem(this.tokenKey);
    return userData;
  }

  getUserEmail() {
    const userData = this.getUserInfo();
    return userData.userDetail?.email;
  }
}
